import { InvestmentWorkflowType } from '@dealstack/shared/lib/generated';
import { Badge, Group, Text } from '@mantine/core';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { formatEnumValue } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/utils/formatEnumValue.ts';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2.tsx';

export const DocumentWorkflowTemplateBadges = ({
	items,
	formatItem,
}: {
	items: string[] | InvestmentWorkflowType[] | undefined;
	formatItem?: (item: string | InvestmentWorkflowType) => string;
}) => {
	if (!items || items.length === 0) {
		return <Text c="dimmed">{LONG_DASH}</Text>;
	}

	return (
		<Group gap="xs">
			{items.map((item, index) => (
				<Badge key={index} size="xs" variant="outline" color="gray.4" c="dark">
					<TextV2 variant="sans/11/400" center elipsis>
						{formatItem ? formatItem(item as string) : formatEnumValue(item)}
					</TextV2>
				</Badge>
			))}
		</Group>
	);
};
